import React, { Component } from "react";
import "./Main.css";
import DynamicGrid from "./DynamicGrid";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "invoice_number",
	UseTicketTypeFilter: false,
	ShowNewButton: false,
	ShowGlobalFilter: true,
};
export class ProposalAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Proposals: [],
		};
		this.getData();
	}
	async getData() {
		const data = await fetch("Proposal/GetProposals", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		});
		var res = await data.json();
		this.setState({ Proposals: res });
	}

	async approveProposal(row) {
		await fetch("Proposal/ApproveProposal", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ invoiceId: row["invoice_header_id"] }),
		});
		this.getData();
	}

	render() {
		var config = [
			{ header: "Estimate #", columnName: "invoice_number", visible: true, typeCode: "S" },
			{ header: "Building", columnName: "building_name", visible: true, typeCode: "S" },
			{ header: "Approved?", columnName: "is_approved", visible: true, typeCode: "L" },
			{ header: "Signature", columnName: "signature", visible: true, typeCode: "IMG" },
			{ header: "Date Signed", columnName: "signed_date", visible: true, typeCode: "D" },
			{ header: "Approve", columnName: "", visible: true, typeCode: "ACTION", OnClick: (row) => this.approveProposal(row) },
		];
		return (
			<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
				<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
					<DynamicGrid Title="Estimates" Configuration={config} DataSet={this.state.Proposals} Settings={Settings} OnRowClick={(row) => {}} />
				</div>
			</div>
		);
	}
}
